import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import app from './app';
import appConfig from './app-config';
import verticalMenu from './vertical-menu';
import flags_controller_pipelines from './new-pipeline/flags-controller';
import auth from './auth';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    flags_controller_pipelines,
    auth
  },
  strict: process.env.DEV
});
